import { render, staticRenderFns } from "./TipsCustom.vue?vue&type=template&id=4d472c9c&scoped=true&"
import script from "./TipsCustom.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TipsCustom.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TipsCustom.vue?vue&type=style&index=0&id=4d472c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d472c9c",
  null
  
)

export default component.exports